import { render } from "./ContractDetail.vue?vue&type=template&id=c1637fb6&ts=true"
import script from "./ContractDetail.vue?vue&type=script&lang=ts"
export * from "./ContractDetail.vue?vue&type=script&lang=ts"

import "./ContractDetail.vue?vue&type=style&index=0&id=c1637fb6&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__